import Dialog from "./Dialog";

const DIALOG_WIDTHS = {
  large: "1000px",
  medium: "800px",
  small: "600px",
  mini: "400px",
};

export default {
  /**
   * size 	medium / default / small / mini
   */
  create({ title = "标题", width, size = "medium", customClass }) {
    let _width = undefined;
    if (width) {
      _width = width;
    } else if (size) {
      _width = DIALOG_WIDTHS[size];
    }
    return new Dialog(title, _width, customClass);
  },
  closeAll() {
    Dialog.closeAll();
  },
};
